import React from 'react'

import ContentHeader from '../../components/ContentHeader'

class Header extends React.PureComponent {
  render() {
    return (
      <ContentHeader
        title="REPORT: Cumulative Quarterly Review Route Cost Analysis"
        showBackButton
      />
    )
  }
}

export default Header
